import React from 'react';

import card2 from '../img/advantages/dragndrop.png';
import askAi from '../img/advantages/frontend.svg';
import card3 from '../img/advantages/rules.png';
import backgroundBorder from '../img/backgroundBorder.png';
import backgroundGreen from '../img/backgroundGreen.svg';
import backgroundOrange from '../img/backgroundOrange.svg';
import backgroundYellow from '../img/backgroundYellow.svg';
import drawing from '../img/stack/drawing.png';
import stackMountain from '../img/stack/stackMountain.svg';

export const Advantages = React.memo(() => (
  <div
    id="advantages"
    className="mx-auto mb-[61px] flex h-full max-w-[1260px] flex-col items-center justify-center bg-white p-[20px]"
  >
    <div className="flex flex-col items-center justify-center" data-aos="fade-up" data-aos-delay="300">
      <h1 className="text-[17.02px] font-[700] leading-[30.6px] text-[#FA5B30] ">The AI Advantage</h1>
      <h1 className="mt-[12px] text-center text-[45px] font-[700] leading-[67.2px] tracking-[-1.5px] lg:text-[54.03px] ">
        What makes you unstoppable
      </h1>
      <p className="mt-[30px] max-w-[660px] text-center text-[16.59px] font-[400] leading-[30.6px] text-neutral-800">
        With the perfect combo of AI and a visual editor, you won’t just keep up—you’ll lead. Your code and designs stay
        sharp, consistent, and ready to impress.
      </p>
    </div>
    <div
      className="mt-[10px] flex flex-row flex-wrap justify-center gap-[24px] pt-[30px]"
      data-aos="fade-up"
      data-aos-delay="300"
    >
      <div data-aos="zoom-in" data-aos-delay="200">
        <div className="h-[543px] max-w-[384px] rounded-[24px] border bg-[#F8F4F2] p-[41px_27px] transition-transform duration-300 hover:scale-105">
          <div>
            <img src={backgroundOrange} alt="Orange background graphic" />
          </div>
          <div>
            <h1 className="mt-[15px] text-[19px] font-bold leading-[34px]">Frontend, Fast and Fearless</h1>
            <p className="mt-[16px] text-[15px] font-[400px] leading-[27px] text-[#454140]">
              Launch your first component in seconds and show everyone how it’s done.
            </p>
            <div className="mt-[26px]">
              <img src={askAi} alt="Ask AI icon" />
              <img src={backgroundBorder} alt="Decorative border graphic" />
            </div>
          </div>
        </div>
      </div>
      <div data-aos="zoom-in" data-aos-delay="200">
        <div className="h-[543px] max-w-[384px] rounded-[24px] border bg-[#F8F4F2] p-[41px_27px] transition-transform duration-300 hover:scale-105">
          <div>
            <img src={backgroundGreen} alt="Green background graphic" />
          </div>
          <div>
            <h1 className="mt-[15px] text-[19px] font-bold leading-[34px]">AI Meets Visual Code Editor</h1>
            <p className="mt-[16px] text-[15px] font-[400px] leading-[27px] text-[#454140]">
              This isn’t just AI—it’s a complete studio. Combine machine power with your expertise to perfect every
              component.
            </p>
            <div className="mt-[50px]">
              <img src={card2} alt="Card showing AI editor interface" />
            </div>
          </div>
        </div>
      </div>
      <div data-aos="zoom-in" data-aos-delay="200">
        <div className="h-[543px] max-w-[384px] rounded-[24px] border bg-[#F8F4F2] p-[41px_27px] transition-transform duration-300 hover:scale-105">
          <div>
            <img src={backgroundYellow} alt="Yellow background graphic" />
          </div>
          <div>
            <h1 className="mt-[15px] text-[19px] font-bold leading-[34px]">Rules That Rule</h1>
            <p className="mt-[16px] text-[15px] font-[400px] leading-[27px] text-[#454140]">
              Why settle for defaults when you can define the standard? Enforce your team’s rules easily.
            </p>
            <div className="mt-[48px]">
              <img src={card3} alt="Card illustrating rules enforcement" />
            </div>
          </div>
        </div>
      </div>
      <div
        className="relative mt-[39px] flex size-full flex-col items-center overflow-hidden rounded-[20px] bg-[#F8F4F2] bg-cover px-[30px] bg-blend-overlay"
        style={{ backgroundImage: `url(${drawing})` }}
      >
        <div className="flex flex-col items-center gap-[15px]" data-aos="zoom-in" data-aos-delay="200">
          <h1 className="mt-[60px] text-center text-[32px] font-[700] leading-[41px] tracking-[-1.5px] md:text-[54.03px]  md:leading-[67.2px]">
            Work with your favorite tools
          </h1>
          <p className="mt-[15px] max-w-[440px] text-center text-[16.59px] font-[400] leading-[30.6px] text-neutral-800">
            Clean code, ready to integrate with the tools you love. No learning curve—just plug and play.
          </p>
          <button
            className="mt-[15px] flex h-[46px] items-center justify-center rounded-[100px] bg-black px-[30px] font-bold text-white transition-all duration-200 hover:bg-primary hover:shadow-xl sm:h-[50px]"
            onClick={() => {
              window.open('https://app.webcrumbs.ai/', '_blank');
            }}
          >
            {/* See Integrations */}
            See it in action
          </button>
        </div>
        <div className="flex" data-aos="fade-up" data-aos-delay="200">
          <img
            src={stackMountain}
            alt="Mountain graphic"
            className="transition-transform duration-300 hover:-translate-y-2 hover:scale-105"
          />
        </div>
      </div>
    </div>
  </div>
));
